<template>
  <div class="down_load_box" v-if="down_show">
    <div class="down_load_ct">
      <div class="down_load_mark"></div>
      <div class="down_load_option">
        <!-- 头部渐变 -->
        <div class="linear">
          <div class="linear_lt">
            <img style="display: none;"
              :src="isloginType == 'phone' ? require('@/assets/image/phone_icon.png') : require('@/assets/image/pass_icon.png')"
              alt="">
          </div>
          <div class="code_title">游戏下载</div>
          <div class="linear_rt">
            <img src="@/assets/image/reserve_cancel_ic.png" alt="">
          </div>
        </div>
        <!-- 下载 -->
        <div class="option_ct">
          <div class="option_ct_lt">
            <h5>用电脑模拟器玩</h5>
            <img src="@/assets/image/cpt.png" alt="">
            <div class="down_btn">下载到电脑</div>
          </div>
          <div class="shu"></div>
          <div class="option_ct_rt">
            <h5>用手机游玩</h5>
            <img src="@/assets/image/qr_code.png" alt="">
            <div class="code_login">
              用微信/浏览器扫码打开
              <p> 50游戏APP</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownLoad',
  props: {
    down_show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.down_load_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
}

.down_load_ct {
  position: relative;
  width: 100%;
  height: 100%;

  .down_load_mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .down_load_option {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 550px;
    // height: 684px;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 0 0 40px 0;
    z-index: 2;

    .linear {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 50px;
      padding: 25px 26px 10px 46px;
      box-sizing: border-box;
      border-radius: 20px 20px 0 0;
      background: linear-gradient(to bottom, #FFE8E9, #FFFFFF);

      .linear_lt {
        cursor: pointer;
      }

      .code_title {
        font-size: 20px;
        font-weight: 700;
      }

      .linear_rt {
        width: 16px;
        height: 16px;
        // align-self: flex-start;
      }
    }

    .option_ct {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 60px;

      .option_ct_lt {
        h5 {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.9);
          margin-bottom: 30px;
        }

        img {
          width: 162px;
          height: 135px;
        }

        .down_btn {
          width: 152px;
          height: 42px;
          margin: 30px auto 0;
          line-height: 42px;
          font-size: 14px;
          color: #ffffff;
          background-color: #FF3838;
          border-radius: 21px;
        }
      }

      .shu {
        width: 1px;
        height: 215px;
        background-color: #E6E6E6;
      }

      .option_ct_rt {
        h5 {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.9);
          margin-bottom: 30px;
        }

        img {
          width: 140px;
          height: 140px;
        }

        .code_login {
          margin-top: 30px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.8);

          p {
            color: #FF3838;
            margin-top: 6px;
          }
        }
      }
    }
  }

}
</style>
